import React from "react";
import withProviders from "../../hooks/withProviders";
import AdministrationNewMoney from "../../features/administrationnewmoney";
import { FilterProvider, NewMoneyDefaultFilters } from "../../hooks/FilterContext";

const AdministrationNewMoneyPage = () => <AdministrationNewMoney />

export default withProviders([FilterProvider, { defaultFilters: NewMoneyDefaultFilters }])(AdministrationNewMoneyPage);